import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Forbidden from './pages/Forbidden';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Reps from './pages/Reps';
import Support from './pages/Support';
import ActionsCenter from './pages/ActionsCenter';
import UpdateAvailableBanner from './components/UpdateAvailableBanner';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forbidden" element={<Forbidden />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:tenantId" element={<ClientDetail />} />
              <Route path="/actions" element={<ActionsCenter />} />
              <Route path="/reps" element={<Reps />} />
              <Route path="/support" element={<Support />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        {/* New-build prompt: pinned on every route, including login */}
        <UpdateAvailableBanner />
      </BrowserRouter>
    </AuthProvider>
  );
}
